<template>
    <el-drawer
        title="审核项目"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <table v-if="itemData" class="info-table" width='100%'>
                <tr>
                    <th>众筹ID</th>
                    <td>{{itemData.id}}</td>
                </tr>
                <tr>
                    <th>众筹名称</th>
                    <td>{{itemData.title}}</td>
                </tr>
                <tr>
                    <th>目标众筹金额</th>
                    <td>{{itemData.raiseMoneyFormat}}</td>
                </tr>
                <tr>
                    <th>发起人</th>
                    <td>{{itemData.promoterName}}</td>
                </tr>
                <tr>
                    <th>开始结束时间</th>
                    <td>{{itemData.startTime}} - {{itemData.endTime}}</td>
                </tr>
            </table>
            <el-alert
                title="如果审核不通过，请在备注中写明原因，用户会收到相应通知"
                type="warning"
                :closable="false"
            >
            </el-alert>
            <el-form :model="formData" ref="formData" label-position="top">
                <el-form-item prop="status" label="是否通过审核:" required>
                    <el-radio-group
                        v-model="formData.status"
                        @change="$refs.formData.clearValidate()"
                    >
                        <el-radio :label="2">是</el-radio>
                        <el-radio :label="5">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    prop="remark"
                    :rules="[
                        {
                            required: formData.status == 5 ? true : false,
                            message: '请输入备注',
                        },
                    ]"
                >
                    <span slot="label">备注: <small class="color-info">如果拒绝,请填写原因</small></span>
                    <el-input
                        v-model="formData.remark"
                        placeholder="请输入备注"
                        type="textarea"
                    ></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button
                type="primary"
                @click="submitForm()"
                :loading="btnLoading"
                >确定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    id: "",
    remark: "",
    status: 2,
}
export default {
    data() {
        return {
            drawerShow: false,
            dataLoading: false,
            btnLoading: false,
            formData: {
                ...defaultFormData
            },
            itemData:null
        };
    },
    methods: {
        close() {
            this.formData = { ...defaultFormData };
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(data) {
            this.itemData = data;
            this.formData.id = data.id;
            this.drawerShow = true;
        },
        //表单提交
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    const _url = this.formData.status == 2 ? "/raise/audit/pass" : "/raise/audit/fail";
                    this.btnLoading = true;
                    this.$request({
                        url: _url,
                        params: {...this.formData},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.close();
                                setTimeout(() => {
                                    this.$emit('onUpdate');
                                    this.btnLoading = false;
                                },800);
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                                this.btnLoading = false;
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                            this.btnLoading = false;
                        })
                        .finally(() => {
                            //this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.el-alert {
    margin: 20px 0;
}
</style>